import { useState, useEffect }                              from 'react';
import { Box }                                              from '@mui/material';
import { LocalizationProvider }                             from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs }                                     from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker }                                       from '@mui/x-date-pickers/DatePicker';
import { makeStyles }                                       from '@mui/styles';
import { ptBR }                                             from '@mui/x-date-pickers/locales';
import dayjs                                                from 'dayjs';
import customParseFormat                                    from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);


const useStyles = makeStyles({
    root: {
        "& .MuiOutlinedInput-input": {
            fontFamily: 'Saira !important',
            margin: 0,
            padding: '7px'
        }
    }
});

const dateType = {

    default:    { format: "DD/MM/YY",    views: ["day", "month", "year"], toConvertFormat: "YYYY-MM-DD" },
    day:        { format: "DD/MM/YY",    views: ["day", "month", "year"], toConvertFormat: "YYYY-MM-DD" },
    month:      { format: "MM/YY",       views: ["month", "year"],        toConvertFormat: "YYYY-MM"    },
    year:       { format: "YYYY",        views: ["year"],                 toConvertFormat: "YYYY"       }  

}


function DateInput({ 

    selectedDateType, 
    onChange, 
    datesList,
    defaultValue

}) {
 
    const classes = useStyles();
    const [ __dateType,         __setDateType         ] = useState('default');
    const [ _safeDefaultValue,   _setSafeDefaultValue ] = useState(null);
    
    useEffect(() => {
        
        const nextType = selectedDateType || "default";
        __setDateType(nextType);

        const dateFormat = dateType[nextType].format;

        const safeValue =
            !defaultValue ? null :
            dayjs.isDayjs(defaultValue) ? defaultValue :
            dayjs(defaultValue, dateFormat, true);

        _setSafeDefaultValue(safeValue);


    }, [selectedDateType, defaultValue]);

    return (

        <div className="flex gap-[10px] flex-row text-[0.8rem] text-nowrap">
            
            {/* Filtro de data */}
            <Box sx={{ width: 200}}>
                
                <LocalizationProvider 
                    
                    dateAdapter={AdapterDayjs}
                    adapterLocale="pt-br"
                    localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    
                >

                <DatePicker

                    minDate={dayjs('2010-01-01')}   
                    maxDate={dayjs('2040-12-31')}   
                    
                    className={classes.root}
                    
                    format={dateType[__dateType].format}
                    views={dateType[__dateType].views}
                    
                    value={_safeDefaultValue}
                    onChange={(newValue) => onChange(newValue)}
                    slotProps={{ textField: { size: 'small' } }}

                    onError={(reason, value) => {

                        console.log("❌ DatePicker error reason:", reason);
                        console.log("❌ DatePicker value:", value?.format?.());
                        console.log("❌ DatePicker value:", value);

                    }}

                    {...(Array.isArray(datesList) && datesList.length > 0 && selectedDateType === 'month' && {
                        
                        shouldDisableMonth: (date) => {
                            const formatted = date.format('MM/YY');
                            return !datesList.includes(formatted);
                        },

                        shouldDisableYear: (date) => {
                            const year = date.format('YY');
                            return !datesList.some((m) => m.endsWith(`/${year}`));
                        }

                    })}

                    {...(Array.isArray(datesList) && datesList.length > 0 && selectedDateType === 'year' && {
                        shouldDisableYear: (date) => {
                            const formatted = date.format('YYYY');
                            return !datesList.includes(formatted);
                        }
                    })}

                    {...(Array.isArray(datesList) && datesList.length > 0 && selectedDateType === 'day' && {
                        shouldDisableDate: (date) => {
                            const formatted = date.format('DD/MM/YY');
                            return !datesList.includes(formatted);
                        }
                    })}
                
                    
                />

                </LocalizationProvider>

            </Box>

        </div>
    );
}

export default DateInput;